/* eslint-disable */
// @ts-nocheck
import { AfterViewInit, Directive, ElementRef, forwardRef, HostListener, OnDestroy, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
	standalone: false,
	selector: '[qeCustomInput]',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CustomInputDirective),
			multi: true,
		},
	],
})
export class CustomInputDirective implements ControlValueAccessor, AfterViewInit, OnDestroy {

	 
	private innerValue!: any;
	private optionToggleObserver?: MutationObserver;
	public disabled: boolean = false;

	@HostListener('blur', ['$event'])
	public handleTouch (ev: UIEvent) {
		this.onTouched();
	}
	@HostListener('click', ['$event'])
	public handleTouchClick (ev: UIEvent) {
		this.onTouched();
	}
	@HostListener('epiValueChanged', ['$event'])
	public handleChange (ev: CustomEvent) {
		const detail = ev?.detail;
		const nextValue = detail && typeof detail === 'object' && 'value' in detail
			? detail.value
			: detail;
		this.value = nextValue;
		this.syncOptionToggleSelection(nextValue);
	}

	public onChange: any = () => { };
	public onTouched: any = () => { };

	public get value (): any {
		return this.innerValue;
	}

	public set value (val: any) {
		this.innerValue = val;
		this.onChange(val);
	}

	constructor (
		private readonly el: ElementRef,
		private readonly renderer: Renderer2,
	) { }

	ngAfterViewInit(): void {
		if (this.el.nativeElement?.localName !== 'epi-option-toggle') {
			return;
		}

		this.optionToggleObserver = new MutationObserver(() => {
			this.syncOptionToggleSelection(this.innerValue);
		});

		this.optionToggleObserver.observe(this.el.nativeElement, {
			childList: true,
			subtree: true,
		});
	}

	ngOnDestroy(): void {
		this.optionToggleObserver?.disconnect();
	}

	/** Handles the value being updated programatically */
	writeValue (value: any): void {
		try {
			this.innerValue = value;
			this.renderer.setProperty(
				this.el.nativeElement,
				'value',
				value,
			);
			this.syncOptionToggleSelection(value);
		} catch (error) {
			datadogRum.addError('QuotaExceededError', {
				storageSession: window.sessionStorage,
				errorMessage: error.message,
			});
		}
	}

	/** Handles the change of the control's value */
	registerOnChange (fn: any): void {
		this.onChange = fn
	}

	/** Handles the 'touched' state of the control */
	registerOnTouched (fn: any): void {
		this.onTouched = fn;
	}

	/** FIXME: this needs to se the disabled state on inputs and the dropdowns */
	setDisabledState (isDisabled: boolean): void {
		this.disabled = isDisabled;
		this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
		this.syncOptionToggleSelection(this.innerValue);
	}

	private syncOptionToggleSelection(value: any): void {
		if (this.el.nativeElement?.localName !== 'epi-option-toggle') {
			return;
		}

		const optionEls = this.el.nativeElement.querySelectorAll('epi-toggle-choice');
		const valueToSync = value === undefined ? this.el.nativeElement.value : value;
		const normalizedValue = valueToSync === null || valueToSync === undefined ? '' : `${valueToSync}`;

		optionEls.forEach((optionEl: any) => {
			const optionValue = optionEl?.value === null || optionEl?.value === undefined ? '' : `${optionEl.value}`;
			optionEl.selected = optionValue === normalizedValue;
		});
	}

}
